export const domain = 'https://chancellorswaypharmacy.com/';
